import { useState, useEffect } from 'react'

export function useIsMobile(esik = 768) {
  const [mobil, setMobil] = useState(() => typeof window !== 'undefined' && window.innerWidth <= esik)
  useEffect(() => {
    const onResize = () => setMobil(window.innerWidth <= esik)
    window.addEventListener('resize', onResize)
    window.addEventListener('orientationchange', onResize)
    onResize()
    return () => {
      window.removeEventListener('resize', onResize)
      window.removeEventListener('orientationchange', onResize)
    }
  }, [esik])
  return mobil
}

export default useIsMobile
